import React, { useState } from 'react';
import Logo from '../../Assets/Images/logo.png';
import backBtn from '../../Assets/Images/back-btn.svg';
import forgetPassword from '../../Assets/Images/forget-password.svg';
import sucess from "../../Assets/Images/successIcon.svg";
import { Link, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import TPLogo from '../../Assets/Images/TPLogo.png';
import NewTPLogo from '../../Assets/Images/whiteLogo.png';


const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSent , setIsSent] =useState(false)
  const navigate = useNavigate();
   const [isLoading, setIsLoading] = useState(false);
  

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setErrorMessage('Email is required.');
    } else if (!emailRegex.test(email)) {
      setErrorMessage('Please enter a valid email address.');
    } else {
      setErrorMessage('');
      // navigate(`/change-password`);
    }
  };

  // const handleForgotPass = (e) => {
  //   e.preventDefault()
  //   if ( validateForm(email) ) {
  //     setIsSent(false)
  //     setIsLoading(true)
  //     fetch(process.env.REACT_APP_API_URI + `/v4/organisation/forgot`,{
  //       method: "POST",
  //       mode: "cors",
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         email: email,
  //         assessmentId: process.env.REACT_APP_CLIENT_ID,
  //       })
  //     })
  //     .then(response => response.json())
  //     .then(res => {
  //       if ( res.status  === "success") {
  //         setIsSent(true)
  //         setIsLoading(false)
  //         // const orgId = res?.orgId
  //         // navigate(`/password-changed?email=${encodeURIComponent(email)}&&orgId=${encodeURIComponent(orgId)}`);
  //       }else{
  //         setErrorMessage(res?.message);
  //         setIsLoading(false)

  //       }
  //     })
  //   }
  // }

  const handleForgotPass = (e) => {
    e.preventDefault();
    
    // Check if email is empty
    if (!email || email.trim() === '' || !validEmailRegex.test(email)) {
      setErrorMessage('Please enter a valid email address.');
      return;
    }
    
    // If we get here, email is valid - proceed with API call
    setIsSent(false);
    setIsLoading(true);
    
    fetch(process.env.REACT_APP_API_URI + `/v4/organisation/forgot`, {
      method: "POST",
      mode: "cors",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        assessmentId: process.env.REACT_APP_CLIENT_ID,
      })
    })
    .then(response => response.json())
    .then(res => {
      if (res.status === "success") {
        setIsSent(true);
        setIsLoading(false);
        // const orgId = res?.orgId
        // navigate(`/password-changed?email=${encodeURIComponent(email)}&&orgId=${encodeURIComponent(orgId)}`);
      } else {
        setErrorMessage(res?.message);
        setIsLoading(false);
      }
    })
    .catch(error => {
      console.error("Error:", error);
      setErrorMessage("An error occurred. Please try again later.");
      setIsLoading(false);
    });
  }

  const validateForm = (data) => {
    return (
      validEmailRegex.test(data)
    );
  }

  const handleChange=(e)=>{
    setEmail(e.target.value)
    setErrorMessage('')
  }

  console.log("errorMessage" , errorMessage)
  return (
    <div className="container forget-password-container">
      <div className="inner-container">
      <div className="left">
        <img src={NewTPLogo} alt="Logo" style={{ width: "113", height: "129" , objectFit: "contain"}} />
        <h1>Welcome to the <br /> Quadrant Flow Portal  </h1>
      </div>
        <div className="right">
          <form className="form" onSubmit={handleSubmit}>
            <img src={forgetPassword} alt="" className="forget-password-icon" />
            <h2>Forgot Password</h2>
            <p>Enter your email to reset your password</p>
            <div className="input-box">
              <label htmlFor="email">Email<span className="asterisk-mark">*</span></label>
              <input type="email" name="email" id="email" placeholder="Type your email here" value={email} onFocus={()=>{setErrorMessage('')}} onChange={(e) => handleChange(e)} className={errorMessage ? 'input-error' : ''}/>
              {errorMessage && <div className="error-message">{errorMessage}</div>}
            </div>
            {!isSent && ( isLoading ? <button><CircularProgress  style={{'color': '#ffffff'}} size={20} /></button> : <button type="submit" onClick={(e)=> {handleForgotPass(e)}}>Request Password Change</button> )}
            {isSent && <p className='sucess'><img src={sucess} alt='sucess' />A reset link has been sent to your email.</p> }
            <Link to={'/login'}>
              <div className="back-btn">
                <img src={backBtn} alt="" />
                <p>Back</p>
              </div>
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
